import React from 'react'
import PropTypes from 'prop-types'

import { EnhancedInput } from '../enhanced-input'
import { FormLabelControl } from '../form-label-control'

export const FormLabelInput = React.forwardRef(({ label, component, ...rest }, ref) => {
  const hasValue = React.useMemo(() => !!rest.value, [rest.value])

  return (
    <FormLabelControl label={label} hasValue={hasValue}>
      {({ field }) => (
        <EnhancedInput
          ref={ref}
          as={component}
          pt={field?.isFocused || hasValue ? '1.625rem' : '1.125rem'}
          pb={field?.isFocused || hasValue ? '0.625rem' : '1.125rem'}
          {...rest}
        />
      )}
    </FormLabelControl>
  )
})

FormLabelInput.propTypes = {
  label: PropTypes.node.isRequired,
  component: PropTypes.elementType,
}
